import { render, staticRenderFns } from "./Subnavbar-funds.vue?vue&type=template&id=88115726&scoped=true"
import script from "./Subnavbar-funds.vue?vue&type=script&lang=js"
export * from "./Subnavbar-funds.vue?vue&type=script&lang=js"
import style0 from "./Subnavbar-funds.vue?vue&type=style&index=0&id=88115726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88115726",
  null
  
)

export default component.exports